import React, { useEffect, useState } from "react";
import Snackbar from "@mui/material/Snackbar";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import {
  Button,
  Container,
  DataGridButton,
  Title,
  UserDeleteOptionsGreen,
  UserDeleteOptionsRed,
} from "./styles";
import { Alert, AlertColor, Avatar } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { UserPermissions } from "../../App";

interface Props {
  userPermissions: UserPermissions;
}
const Organizations: React.FC<Props> = ({ userPermissions }) => {
  const navigate = useNavigate();

  const [orgDelete, setOrgDelete] = useState("");

  const [tableData, setTableData] = useState([]);

  const deleteOrganization = (id: string) => {
    console.log("Delete: ", id);
    fetch("/api/v1/organization/delete", {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        id,
      }),
    })
      .then((response) => response.json())
      .then((data) => {
        console.log(data);
        if (data?.success === true) {
          getOrganizations();
          setStatusMsg("Organization deleted!");
          setStatusSeverity("success");
          setShowStatus(true);
        } else {
          getOrganizations();
          setStatusMsg(`Cannot delete organization: ${data.reason}`);
          setStatusSeverity("error");
          setShowStatus(true);
        }
      });
  };

  const getOrganizations = () => {
    fetch("/api/v1/organization/all", {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        showHidden: true,
      }),
    })
      .then((response) => response.json())
      .then((data) => {
        data = data.map((org: any) => {
          return {
            id: org.id,
            organization: org.name,
            photo: org.logo,
          };
        });
        setTableData(
          data.filter(
            (value: any) =>
              userPermissions.OrgAdmin.includes(value.id) ||
              userPermissions.ORI.Admin
          )
        );
        setTableLoading(false);
      });
  };

  const [tableLoading, setTableLoading] = useState(false);
  useEffect(() => {
    setTableLoading(true);
    getOrganizations();

    const interval = setInterval(() => {
      getOrganizations();
    }, 5000);
    return () => clearInterval(interval);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const columns = [
    {
      field: "organization",
      headerName: "Organization",
      width: 150,
      renderCell: (params: any) => (
        <>
          <Avatar
            src={params.row.photo}
            sx={{ height: "2rem", width: "2rem", marginRight: "1rem" }}
          />{" "}
          {params.value}
        </>
      ),
    },
    {
      field: "id",
      headerName: "id",
      width: 150,
    },
    {
      field: "action",
      headerName: "Action",
      width: 450,
      renderCell: (params: any) => (
        <span style={{}}>
          <DataGridButton
            onClick={() => {
              navigate(
                process.env.PUBLIC_URL + "/Organizations/View/" + params.row.id
              );
            }}
          >
            View
          </DataGridButton>
          {orgDelete === params.row.organization ? (
            <>
              Delete?{" "}
              <UserDeleteOptionsRed
                onClick={() => {
                  deleteOrganization(params.row.id);
                  setOrgDelete("");
                }}
              >
                Yes
              </UserDeleteOptionsRed>{" "}
              <UserDeleteOptionsGreen
                onClick={() => {
                  setOrgDelete("");
                }}
              >
                No
              </UserDeleteOptionsGreen>
            </>
          ) : (
            <DataGridButton
              style={{ color: "#DB3A34", border: "2px solid #DB3A34" }}
              onClick={() => {
                setOrgDelete(params.row.organization);
              }}
            >
              Delete
            </DataGridButton>
          )}
        </span>
      ),
    },
  ];

  const [showStatus, setShowStatus] = React.useState(false);
  const [statusMsg, setStatusMsg] = React.useState("");
  const [statusSeverity, setStatusSeverity] =
    React.useState<AlertColor>("error");
  const handleCloseStatus = (
    event?: React.SyntheticEvent | Event,
    reason?: string
  ) => {
    if (reason === "clickaway") {
      return;
    }

    setShowStatus(false);
  };

  return (
    <Container>
      <Title>
        Organizations{" "}
        {userPermissions.ORI.Admin && (
          <Button
            onClick={() => {
              navigate(process.env.PUBLIC_URL + "/Organizations/Create");
            }}
          >
            Add new organization
          </Button>
        )}
      </Title>

      <div style={{ height: 500, width: "100%", paddingTop: "1rem" }}>
        <DataGrid
          style={{ fontWeight: 900, color: "rgba(55, 73, 87, 0.7)" }}
          rows={tableData}
          columns={columns}
          disableColumnFilter
          disableColumnSelector
          disableDensitySelector
          components={{ Toolbar: GridToolbar }}
          componentsProps={{
            toolbar: {
              showQuickFilter: true,
              quickFilterProps: { debounceMs: 500 },
            },
          }}
          loading={tableLoading}
        />
      </div>

      <Snackbar
        open={showStatus}
        autoHideDuration={2000}
        onClose={handleCloseStatus}
      >
        <Alert
          onClose={handleCloseStatus}
          severity={statusSeverity}
          sx={{ width: "100%" }}
        >
          {statusMsg}
        </Alert>
      </Snackbar>
    </Container>
  );
};

export default Organizations;
